var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#2e71b6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 25c-3.205 0-6.219-1.248-8.485-3.515C2.248 19.22 1 16.205 1 13c0-3.205 1.248-6.219 3.515-8.485C6.78 2.248 9.795 1 13 1c3.205 0 6.219 1.248 8.485 3.515C23.752 6.78 25 9.795 25 13c0 3.205-1.248 6.219-3.515 8.485C19.22 23.752 16.205 25 13 25z",
    transform: "translate(-1119 -2571) translate(1119 2571)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 2c-2.938 0-5.7 1.144-7.778 3.222C3.144 7.299 2 10.062 2 13c0 2.938 1.144 5.7 3.222 7.778C7.299 22.856 10.062 24 13 24c2.938 0 5.7-1.144 7.778-3.222C22.856 18.701 24 15.938 24 13c0-2.938-1.144-5.7-3.222-7.778C18.701 3.144 15.938 2 13 2m0-2c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0z",
    transform: "translate(-1119 -2571) translate(1119 2571)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "MyriadPro-Bold, Myriad Pro",
    fontSize: "14px",
    fontWeight: 700,
    letterSpacing: "0.02em",
    transform: "translate(-1119 -2571) translate(1132 2589)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.115,
    y: 0
  }, "?")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.c031e329e716f52c5b904611a54c3e7a.svg";
export { ForwardRef as ReactComponent };